import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import SendIcon from '@mui/icons-material/Send';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import ListSearchSection from "../../../utils/Custom/ListSearchSection";
import { toast } from "react-toastify";
import { clienTypes } from "../../../utils/commonComponent/common";
import moment from "moment";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Tooltip, Typography } from "@mui/material";
import { AddButton } from "../../../utils/Custom/Button";
import { handleApprovalIR_coverLetter } from "./coverLetterUtils";
import { notifiy } from "../../notification/Notification";
import { getPermissions } from "../rbac/hasAccess";
import { paginationrowsPerPageOptions } from "../../../utils/commonComponent/commonConstant";
import { textTruncate } from "../../../utils/commonComponent/truncate";

const headers = ["id", "Client", "address", "poNumber", "jobNumber", "inspectionNumber", "Items", // instead of "subcategory"
  // "InspectedBy",
];

const fields = [
  { value: "Client", label: "Client" },
  { value: "jobNumber", label: "Job No" },
  { value: "inspectionNumber", label: "Inspection No" },
  { value: "reportNo", label: "Report No" },
];

const CoverLetterList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => {
    if (row?.approvedBy) {
      alert(`This Cover Letter ${row.reportNo} are Approved.\n\nTo change/update these report details, please withdraw the Cover Letter.`);
      return; // stop navigation
    }
    // Navigate if not approved
    navigate(`/editCoverLetter/${row.id}`);
  };

  const [coveerLetterList, setCoverLetterList] = React.useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "Client");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
  // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));
  const [inpectorList, setinpectorList] = React.useState([]);

  // Menu states
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const [menuRow, setMenuRow] = React.useState(null);

  const userType = localStorage.getItem("type") || "";
  const userID = localStorage.getItem("id") || "";

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
    sessionStorage.setItem("ListPageCount", page);
    sessionStorage.setItem("ListRowsPerPage", rows);
  };

  const handleMenuOpen = (event, row) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuRow(row);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const getWhereClause = () => {
    let whereConditions = "";
    const colMap = {
      Client: "c.companyName",
      jobNumber: "jr.jobNumber",
      inspectionNumber: "jri.inspectionNumber",
      poNumber: "jr.poNumber",
      reportNo: "irc.reportNo",
    };
    const colName = colMap[searchBy];
    if (colName && searchKey.trim()) {
      whereConditions = `WHERE LOWER(${colName}) LIKE LOWER('%${searchKey.trim()}%')`;
    }
    if (userType == 2) {
      whereConditions += whereConditions
        ? ` AND jri.assigneuserID = ${userID} AND irc.approvedBy IS NULL`
        : `WHERE jri.assigneuserID = ${userID} AND irc.approvedBy IS NULL`;
    }

    // Always include ir.mode = 2
    whereConditions += whereConditions
      ? ` AND ir.mode = 2`
      : `WHERE ir.mode = 2`;

    return whereConditions;
  };
  const getDataQuery = () => {
    const whereClause = getWhereClause();
    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)}`;
    }
    return `SELECT jri.id AS id, jri.assigneuserID, jri.jobRegisterId, jri.servicesNameId, ii.subcategory, jri.inspectionNumber, jri.status, jr.jobNumber, jr.poNumber, jr.inspectionStartDate, c.id AS client_id, c.companyName as Client, c.type as clientType,irc.requestApproval,irc.subjet, irc.inspectorId as IRCinspector,  irc.rejectedBy, irc.approvedBy, ir.reportNo, ir.issueDate, addr.address AS address, irc.reportNo as coverLetterreportNo FROM jobRegisterInspection jri LEFT JOIN jobRegister jr ON jri.jobRegisterId = jr.id LEFT JOIN clients c ON jr.clientId = c.id LEFT JOIN addresses addr ON jr.address = addr.id LEFT JOIN inspectionItems ii ON jri.servicesNameId = ii.id LEFT JOIN IR ir ON jri.id = ir.jobRegisterInspectionId  LEFT JOIN IR_coverLetter irc ON jri.id = irc.jobRegisterId  ${whereClause} ORDER BY jri.id DESC ${paginationSettings};`;
  }

  const getCountQuery = () => {
    const whereClause = getWhereClause();
    return `SELECT COUNT(*) AS totalRows FROM jobRegisterInspection jri LEFT JOIN jobRegister jr ON jri.jobRegisterId = jr.id LEFT JOIN clients c ON jr.clientId = c.id LEFT JOIN addresses addr ON jr.address = addr.id LEFT JOIN inspectionItems ii ON jri.servicesNameId = ii.id LEFT JOIN IR ir ON jri.id = ir.jobRegisterInspectionId  LEFT JOIN IR_coverLetter irc ON jri.id = irc.jobRegisterId  ${whereClause};`;
  };

  const fetchData = async () => {
    try {
      const [inspectionData, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);
      const modifiedData = inspectionData?.map((item) => {
        const inspectortype = inpectorList.find((el) => el.id == item.assigneuserID);
        return {
          ...item,
          Items: item.subcategory || "",
          "InspectedBy": inspectortype ? inspectortype.name : null,
          Client: item.Client + (item.clientType ? ` (${clienTypes.find((ct) => ct.value == item.clientType)?.short || ""})` : ""),
        };
      });
      setCoverLetterList(modifiedData);
      setTotalRows(countResult?.[0]?.totalRows || 0);
    } catch (error) {
      console.error("Error fetching cover data:", error);
    }
  };

  const updateCoverLetterStatus = async (ids) => {
    const confirmAction = window.confirm(
      "Are you sure you want to send for approval?"
    );

    if (!confirmAction) return;
    try {
      const normalizedIds = Array.isArray(ids) ? ids : [ids];
      const query = `update IR_coverLetter SET requestApproval = 2 WHERE jobRegisterId IN  (${normalizedIds.join(",")})`;
      await fetchQuery(query);
      toast.success("Sent for approval successfully!");
      setTimeout(() => window.location.reload(), 500);
    } catch (error) {
      console.error("Failed to update inspection status:", error);
    }
  };

  // Add these states near your other states (around line 48)
  const [withdrawalDialogOpen, setWithdrawalDialogOpen] = React.useState(false);
  const [withdrawalReason, setWithdrawalReason] = React.useState("");
  const [withdrawalId, setWithdrawalId] = React.useState(null);
  const [withdrawalRowData, setWithdrawalRowData] = React.useState(null);

  // Add this new function to handle the actual withdrawal
  const handleConfirmWithdrawal = async () => {
    try {
      const normalizedIds = Array.isArray(withdrawalId) ? withdrawalId : [withdrawalId];
      const query = `update IR_coverLetter SET requestApproval = 1, approvedBy = NULL, rejectedBy = NULL WHERE jobRegisterId IN (${normalizedIds.join(",")})`;
      await fetchQuery(query);

      // Get inspection numbers and test names for notification
      const getSelectedInspectionNumbers = () => {
        return coveerLetterList
          .filter(i => normalizedIds.includes(i.id))
          .map(i => i.inspectionNumber)
          .join(", ");
      };

      const getSelectedTestNames = () => {
        const tests = coveerLetterList
          .filter(i => normalizedIds.includes(i.id))
          .map(i => i.Items)
          .filter(Boolean);
        return [...new Set(tests)].join(", ");
      };

      const inspectionNumbers = getSelectedInspectionNumbers();
      const testNames = getSelectedTestNames();

      // Send notification to inspectortypo
      const inspectorIdToNotify = withdrawalRowData?.inspectorId;

      if (inspectorIdToNotify) {
        const notification = {
          _from: userID,
          _to: inspectorIdToNotify,
          body: `Cover Letter Approval Withdrawn
  Report No       : ${withdrawalRowData?.reportNo || ""}
  Job No       : ${withdrawalRowData?.jobNumber || ""}
  Inspection No: ${inspectionNumbers}
  Test Name    : ${testNames}
  Reason       : ${withdrawalReason}`,
          datasheetIds: normalizedIds.join(","),
          type: 1,
        };
        setTimeout(() => {
          notifiy(notification, () => {
            console.log(`Notification sent for withdrawal`);
          });
        }, 100);
      }
      toast.success("Withdrawn successfully!");
      // Reset states
      setWithdrawalDialogOpen(false);
      setWithdrawalReason("");
      setWithdrawalId(null);
      setWithdrawalRowData(null);
      setTimeout(() => window.location.reload(), 500);
    } catch (error) {
      console.error("Failed to withdraw:", error);
      toast.error("Failed to withdraw approval");
    }
  };

  // Add this function to handle dialog close
  const handleCloseWithdrawalDialog = () => {
    setWithdrawalDialogOpen(false);
    setWithdrawalReason("");
    setWithdrawalId(null);
    setWithdrawalRowData(null);
  };

  const jobWithdrawApproval = async (id, rowData) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to withdraw the approval?"
    );
    if (!isConfirmed) return;
    // Open dialog instead of direct confirmation
    setWithdrawalId(id);
    setWithdrawalRowData(rowData);
    setWithdrawalDialogOpen(true);
  };

  // const jobWithdrawApproval = async (ids) => {
  //     const isConfirmed = window.confirm(
  //       "Are you sure you want to withdraw the approval?"
  //     );
  //     if (!isConfirmed) return;
  //     try {
  //       const normalizedIds = Array.isArray(ids) ? ids : [ids];
  //       const query = `update IR_coverLetter SET requestApproval = 1, approvedBy = NULL, rejectedBy = NULL WHERE jobRegisterId IN  (${normalizedIds.join(",")})`;
  //       await fetchquery(query);
  //       toast.success("Withdraw successfully!");
  //       setTimeout(() => window.location.reload(), 500);
  //     } catch (error) {
  //       console.error("Failed to update withdraw:", error);
  //     }
  //   };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("Client");
    setSearchKey("");
    // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  const hasRole = ["2"].some(role => (localStorage.getItem("roles") || "").split(",").includes(role)) || userType == 1 || userType == 5;
  const [selectedIds, setSelectedIds] = React.useState([]);
  const [selectedApproveIds, setselectedApproveIds] = React.useState([]);
  // Fixed: Calculate isAllSelected based on valid selectable rows only
  const validSelectableRows = coveerLetterList.filter(row => row.IRCinspector && !row.approvedBy);
  const isAllSelected = validSelectableRows.length > 0 && selectedIds.length === validSelectableRows.length;
  const handleSelectAll = () => {
    const validRows = coveerLetterList.filter(
      row => row.IRCinspector && !row.approvedBy
    );
    const validIds = validRows.map(row => row.id);

    if (selectedIds.length === validIds.length && validIds.length > 0) {
      setSelectedIds([]);
      setselectedApproveIds([]);
    } else {
      setSelectedIds(validIds);
      setselectedApproveIds(validIds);
    }
  };
  const handleSelectRow = (id) => {
    const updated = selectedIds.includes(id)
      ? selectedIds.filter((item) => item !== id)
      : [...selectedIds, id];
    setSelectedIds(updated);
    setselectedApproveIds(updated);
  };

  const fetchinpectorsList = async () => {
    const query = `SELECT user.*, emp.name, emp.location FROM users user LEFT JOIN employees emp ON user.employeeId = emp.id WHERE user.type = 2 AND user.status = 1`;
    const res = await fetchQuery(query);
    setinpectorList(res);
  };

  useEffect(() => {
    fetchData();
  }, [inpectorList, currentPage, rowsPerPage]);

  useEffect(() => {
    fetchinpectorsList();
  }, []);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      <ListSearchSection
        title="Search Cover Letter"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      {/* {hasRole && selectedApproveIds.length > 0 && (
        <>
          <AddButton
            id="btn-add-outline"
            label="Approve"
            onClick={() => handleApprovalIR_coverLetter(selectedApproveIds)}
          />
          <br />
          <br />
        </>
      )} */}


      <div className="w-full border rounded-md shadow">
        <div className="overflow-y-auto h-auto max-h-[550px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs font-medium text-gray-600 z-10">
              <tr>
                {/* {hasRole && (
                  <th className="px-2 py-3 text-center">
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  </th>
                )} */}
                <th className="whitespace-nowrap px-4 py-3">Sr. No.</th>
                <th className="whitespace-nowrap px-4 py-3">Client</th>
                <th className="whitespace-nowrap px-4 py-3">Address</th>
                <th className="whitespace-nowrap px-4 py-3">Report Number</th>
                <th className="whitespace-nowrap px-4 py-3">PO Number</th>
                <th className="whitespace-nowrap px-4 py-3">Job Number</th>
                <th className="whitespace-nowrap px-4 py-3">Inspection Number</th>
                <th className="whitespace-nowrap px-4 py-3">Items</th>
                {(permissions.edit || permissions.pdfDownload || permissions.allAccess) && (
                  <th className="whitespace-nowrap px-4 py-3 text-center">Actions</th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {coveerLetterList.map((row, rowIndex) => {
                // Determine background color for reportNo column
                const bgColor =
                  row.IRCinspector && row.rejectedBy
                    ? "bg-[#FF3F33]"
                    : row.IRCinspector && row.approvedBy
                      ? "bg-[#b0b0fa]"
                      : row.requestApproval === 2
                        ? "bg-red-200"
                        : row.IRCinspector && !row.approvedBy
                          ? "bg-[#b5ebe3]"
                          : "";

                return (
                  <tr key={rowIndex}
                    className={`px-4 py-3 ${bgColor}`}>
                    {/* {hasRole && (
                    <td className="px-2 py-2 text-center">
                      <input
                        type="checkbox"
                        disabled={!(row.subjet && !row.approvedBy)}
                        checked={selectedIds.includes(row.id)}
                        onChange={() => handleSelectRow(row.id)}
                      />
                    </td>
                  )} */}
                    <td className="px-4 py-3">{currentPage * rowsPerPage + rowIndex + 1}</td>
                    <td onClick={() => handleEdit(row)} className="cursor-pointer hover:text-blue-600 px-4 py-3">{textTruncate(row.Client) ?? "-"}</td>
                    <td className="px-4 py-3">{textTruncate(row.address) ?? "-"}</td>
                    <td onClick={() => handleEdit(row)} className="cursor-pointer hover:text-blue-600 px-4 py-3">{row.coverLetterreportNo || "-"}</td>
                    <td className="px-4 py-3">{row.poNumber ?? "-"}</td>
                    <td className="px-4 py-3">{row.jobNumber ?? "-"}</td>
                    <td onClick={() => handleEdit(row)} className="cursor-pointer hover:text-blue-600 px-4 py-3">{row.inspectionNumber ?? "-"}</td>
                    <td className="px-4 py-3">{row.Items ?? "-"}</td>
                    <td className="px-4 py-2 text-center whitespace-nowrap">
                      <div className="flex items-center justify-center gap-2">
                        {(permissions.edit || permissions.allAccess) && (
                          <button
                            onClick={() => handleEdit(row)}
                            className="text-blue-600"
                          >
                            <EditIcon fontSize="small" />
                          </button>
                        )}
                        {userType == 2 && (
                          <button
                            onClick={() => updateCoverLetterStatus(row.id)}
                            disabled={row.requestApproval == 2}
                            className={`text-blue-600 disabled:text-gray-400`}
                          >
                            <Tooltip title="Send For Approval" arrow>
                              <SendIcon fontSize="small" />
                            </Tooltip>
                          </button>
                        )}

                        {hasRole && (
                          <button
                            onClick={() => jobWithdrawApproval(row.id, row)}
                            disabled={!row.approvedBy}
                            className={`text-blue-600 disabled:text-gray-400`}
                          >
                            <Tooltip title="Widhraw Cover Letter" arrow>
                              <RunningWithErrorsIcon fontSize="small" />
                            </Tooltip>
                          </button>
                        )}
                        {(permissions.pdfDownload || permissions.allAccess) && (
                          <IconButton
                            size="small"
                            onClick={(e) => handleMenuOpen(e, row)}
                            className="text-blue-600"
                          >
                            <MoreVertIcon fontSize="small" />
                          </IconButton>
                        )}
                        <Menu
                          anchorEl={menuAnchorEl}
                          open={Boolean(menuAnchorEl && menuRow === row)}
                          onClose={handleMenuClose}
                        >
                          <MenuItem
                            onClick={() => {
                              handleMenuClose();
                              navigate(`/editCoverLetter/print/${menuRow.id}`);
                            }}
                          >
                            <PictureAsPdfIcon
                              fontSize="small"
                              className="text-blue-600 mr-2"
                            />
                            Pdf
                          </MenuItem>
                        </Menu>
                      </div>
                    </td>
                  </tr>
                );
              })}
              {coveerLetterList.length === 0 && (
                <tr>
                  <td
                    colSpan={headers.length + 1}
                    className="text-center py-4 text-gray-500"
                  >
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between px-4 py-2 bg-blue-50 text-sm border-t">
          <div className="flex items-center gap-2">
            <span>Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) => handlePaginationChange(0, Number(e.target.value))}
              className="border rounded px-2 py-1 text-sm"
            >
              {paginationrowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-gray-600">
              {totalRows === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                  (currentPage + 1) * rowsPerPage,
                  totalRows
                )} of ${totalRows}`}
            </span>
            <button
              onClick={() => handlePaginationChange(0, rowsPerPage)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(currentPage - 1, rowsPerPage)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(currentPage + 1, rowsPerPage)}
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handlePaginationChange(Math.ceil(totalRows / rowsPerPage) - 1, rowsPerPage)}
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>

      {/* Withdrawal Reason Dialog */}
      <Dialog open={withdrawalDialogOpen}
        onClose={handleCloseWithdrawalDialog}
        maxWidth="sm" fullWidth
      >
        <DialogTitle>Withdraw Approval</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Please provide a reason for withdrawing the approval:
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            label="Reason for Withdrawal"
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            value={withdrawalReason}
            onChange={(e) => setWithdrawalReason(e.target.value)}
            placeholder="Enter the reason for withdrawal..."
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseWithdrawalDialog} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmWithdrawal}
            variant="contained"
            color="error"
            disabled={!withdrawalReason.trim()}
          >
            Confirm Withdrawal
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CoverLetterList;
